/**
 * Shop the Look — `hotspotsContentCollection` helpers.
 *
 * Slim region queries may only return `__typename` + `sys` per HotspotContent item; the parent entry
 * can still look "complete" to CONTENTFUL_METADATA, so `useShopTheLookById` is not run from
 * Component. `shopTheLookNeedsFullHotspotFetch` forces a full fetch so nested image/video/text resolve.
 */

/**
 * @param {Record<string, unknown>|null|undefined} component
 * @returns {Array<unknown>|null}
 */
function getHotspotsContentItems(component) {
  const items = component?.hotspotsContentCollection?.items;

  return Array.isArray(items) && items.length > 0 ? items : null;
}

/**
 * @param {Record<string, unknown>|null|undefined} component
 * @returns {boolean}
 */
export function shopTheLookNeedsFullHotspotFetch(component) {
  const items = getHotspotsContentItems(component);

  if (!component?.sys?.id || !items) {
    return false;
  }

  return items.some((item) => item?.__typename === 'HotspotContent');
}

/**
 * Whether linked HotspotContent entries exist (drawer / slides). JSON `productId`-only hotspots
 * omit this collection — standalone chrome stays flush.
 *
 * @param {Record<string, unknown>|null|undefined} component
 * @returns {boolean}
 */
export function shopTheLookHasHotspotsContentCollection(component) {
  const items = getHotspotsContentItems(component);

  if (!items) {
    return false;
  }

  return items.some((item) => item?.__typename === 'HotspotContent' && item?.sys?.id);
}
